import { render, staticRenderFns } from "./KoioteOmronConnectionProperties.vue?vue&type=template&id=5395d6d9&lang=es&"
import script from "./KoioteOmronConnectionProperties.vue?vue&type=script&lang=js&"
export * from "./KoioteOmronConnectionProperties.vue?vue&type=script&lang=js&"
import style0 from "./KoioteOmronConnectionProperties.vue?vue&type=style&index=0&id=5395d6d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports